import PersistentStorage from '../lib/PersistentStorage.js';
import Api from '../api.js';
import FCMFactory from '../lib/FirebaseCloudMessagingFactory';
import ConferenceState from './conference.js';
import QueuesState from  './queues.js'; 

// Global Vue is deprecated. Do not use.
// Instead use this._vm inside the store.
import Vue from 'vue';
import { O_DIRECTORY } from 'constants';
import { rejects } from 'assert';
import { resolve } from 'path';


import { updateDevices} from '../lib/SIPHandler/salesforceHelper.js';

import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';
const logrocketPlugin = createPlugin(LogRocket);

const messageQry = `
query msgqry {
  messages {
    message_id
    to_id
    to_type
    from_id
    from_type
    text
    dated
    msg_group_id
    fromName
    toName
    groupBy
    unread
  }
  myMsgGroups {
    msg_group_id
    name
    subname
    user_id_1
    user_id_2
    name_for_user_1
    name_for_user_2
    unread_messages
    last_message
    last_message_datetime
    phone_number
    conference_id
    MsgGroupMembers {
      msg_group_member_id
      msg_group_id
      reference_entity_id
      reference_entity_type
      name
      subname
      unread_messages
    }
  }
  me {
    user_id
    username
    email
    first_name
    last_name
    fullName
    password
    account_id
    control_account_id
    SMSFromNumbers {
      number
      entity_id
      entity_type
      entity_name
    }
  }
}
`;


const msgGroupQryTxt = `
query msgqry {
  myMsgGroups {
    msg_group_id
    name
    subname
    user_id_1
    user_id_2
    name_for_user_1
    name_for_user_2
    unread_messages
    last_message
    last_message_datetime
    memberCount
    phone_number
    conference_id
  }
}
`;

const messageAddMutation = `
  mutation messsageAddMutation($input: MessageInput) {
    messageAdd(input: $input) {
      message_id
      to_id
      to_type
      from_id
      from_type
      text
      dated
      msg_group_id
      fromName
      toName
      groupBy
      file_s3_region
      file_s3_bucket
      file_s3_key
      file_original_name
      file_content_type
      file_size
    } 
  }
`;

const setReadAllMessagesInGroupMutation = `
  mutation setReadAllMessagesInGroupMutation($msgGroupId: Int!) {
    setReadAllMessagesInGroup(msgGroupId: $msgGroupId)
  }
`;

const onMessageAddMutation = `
subscription onMessageAddMutation($authorization: String!) {
  onMessageAdd(authorization: $authorization) {
    message_id
    to_id
    to_type
    from_id
    from_type
    text
    dated
    msg_group_id
    fromName
    toName
    groupBy
    message_type
    file_s3_region
    file_s3_bucket
    file_s3_key
    file_original_name
    file_content_type
    file_size
  } 
}
`;


let loginMutation = `
  mutation userLogin($username: String!, $password: String!) {
    userLogin(username: $username, password: $password) {
      token
      user {
        user_id
        username
        first_name
        last_name
      }
    }
  }
`;

// This is the state of an EMPTY app configuration. Do not load
// any state data in here. To set initialization data, change the
// setStateFromAuthToken() mutation, which works both on application
// load, and when the auth token is updated for any reason.
const emptyState= () => ({
  // Do not set NODE_ENV to production. run a proper build, and
  // it will set this variable.
  isDevelopment: process.env.NODE_ENV!=='production',
  node_env: process.env.NODE_ENV,
  user: null,
  deviceId: null,
  device: null,
  devices: [],
  ringtone: null,
  ringtones: [],
  lineKeys: [],
  lineBLF: [],
  callHistory: [],
  click2call: null,
  messageSubscription: null,
  msgGroups: [],
  msgGroupSearch: '',
  messages: [],
  users: [],
  number: '',
  smsFromNumbers: [],
  useVOIP: null,
  microphoneId: false,
  cameraId: false,
  speakerId: false,
  activeMsgGroup: null,
  unsentMessages: [],
  gettingMsgGroups: false,
  plugins: [logrocketPlugin]
});


const vuex = {
  modules: {
    conference: ConferenceState,
    queues: QueuesState
  },
  state() {
    // Start with a valid, empty state.
    let state = emptyState();
    return state;
  },
  getters: {
    speakerId: (state) => {
      console.log('getting speaker id');
      let userconfigs = PersistentStorage.get('userconfig');
      let id = userconfigs[state.user.user_id].speakerId;
      return id;
    },
    cameraId: (state) => {
      console.log('getting camera id');
      let userconfigs = PersistentStorage.get('userconfig');
      let id = userconfigs[state.user.user_id].cameraId;
      return id;
    },
    msgGroups: (state) => {
      console.log('getting message groups');
      let groups = state.msgGroups.sort((a, b) => b.last_message_datetime - a.last_message_datetime);
      if (state.msgGroupSearch) {
        groups = groups.filter(group => group.name.toLowerCase().includes(state.msgGroupSearch.toLowerCase())); 
      }
      return groups;
    }
  },
  mutations: {
    // PRIVATE MUTATIONS. DO NOT CALL THESE!! IT WILL BREAK THE APP.
    // THEY ARE ONLY TO BE CALLED FROM setStateFromAuthToken!!
    // WARNING!!! Vuex has no way of making PRIVATE mutations.
    _user(state, user) { state.user=user },
    //
    //
    // OTHER MUTATIONS
    setAppState: (state, newState) => {
      // Copy newState to current state.
      Object.assign(state, newState);

      // Remove all keys not present in newState
      for (let key in state.keys) {
        if (!newState.includes(key)) state.remove('key');
      }
    },
    activeMsgGroup(state, val) {
      state.activeMsgGroup = val;
      console.log('val is ', state.activeMsgGroup)
    },
    msgGroupSearch(state, val) {
      state.msgGroupSearch = val;
    },
    useVOIP(state, flag) { 
      state.useVOIP = !!flag
      let userconfigs = PersistentStorage.get('userconfig');
      userconfigs[state.user.user_id].useVOIP = !!flag;
      PersistentStorage.set('userconfig', userconfigs);
      console.log("WILL RELOAD SIP FOR useVOIP mutation");
      if (this._vm.$sip) this._vm.$sip.reload();
    },
    microphoneId(state, id) { 
      let userconfigs = PersistentStorage.get('userconfig');
      userconfigs[state.user.user_id].microphoneId = id;
      PersistentStorage.set('userconfig', userconfigs);
      Vue.set(state, 'microphoneId', id);
    },
    gettingMsgGroups(state, val) { 
      Vue.set(state, 'gettingMsgGroups', val);
    },
    ringtone(state, obj) { 
      let userconfigs = PersistentStorage.get('userconfig');
      userconfigs[state.user.user_id].ringtoneName = obj.name;
      PersistentStorage.set('userconfig', userconfigs);
      Vue.set(state, 'ringtone', obj);
    },
    cameraId(state, id) { 
      let userconfigs = PersistentStorage.get('userconfig');
      userconfigs[state.user.user_id].cameraId = id;
      PersistentStorage.set('userconfig', userconfigs);
      state.cameraId = id;
    },
    speakerId(state, id) { 
      let userconfigs = PersistentStorage.get('userconfig');
      userconfigs[state.user.user_id].speakerId = id;
      PersistentStorage.set('userconfig', userconfigs);
      //state.speakerId = id;
      Vue.set(state, 'speakerId', id);
    },
    devices(state, devices) { state.devices = devices },
    deviceId(state, deviceId) {
      // Save the device ID
      state.deviceId = deviceId

      // Save the device
      state.device = state.devices.find(e => e.device_id==deviceId);

      // Fetch the configuration for this user
      let userconfigs = PersistentStorage.get('userconfig');

      // Update the configuration with the deviceId
      userconfigs[state.user.user_id].deviceId = deviceId;

      // get line keys associated with this phone
      let api = new Api(global.gqlClient());
      let self = this;
      api.lineKeys(state.device.click2call_token, state.device.device_id).then(function(lineKeys) {
        self.commit('lineKeys', lineKeys);
      });

      // get call history associated with this phone
      api.callHistory(state.device.click2call_token).then(function(history) {
        state.callHistory = history;
      });

      // Re-save the configuration
      PersistentStorage.set('userconfig', userconfigs);

      // Reload SIP
      console.log("WILL RELOAD SIP FOR deviceId MUTATION")
      if (this._vm.$sip) {

        // reload sip
        this._vm.$sip.reload();

        let self = this;
        // subscribe to the recording
        setTimeout(function() { 
          let recBLF = 'REC_' + state.device.login;

          let del = function(notification) {
            Vue.set(this, 'recording', notification['dialog-info'].dialog[0].state[0]);
          }
          self._vm.$sip.subscribe(del.bind(state.device), recBLF);       
        }, 2500);
      }


      
      

    },
    device(state, device) {
      for (let i=0;i<state.devices.length;i++) {
        let d = state.devices[i];        
        if (d.device_id == device.device_id) {
          let props = Object.keys(device);
          for (let i=0;i<props.length;i++) {
            let prop = props[i];
            Vue.set(d,prop,device[prop] );
          }
        }
      }
    },
    lineKeys(state, lineKeys) {
      var blfDelegate = function(notification) {
        Vue.set(this, 'blfState', notification['dialog-info'].dialog[0].state[0]);
      }
      console.log('linekeys are ', lineKeys);
      for (var i in lineKeys){
        console.log('line key ', lineKeys[i].number, ' has corresponding lineBLF ', state.lineBLF.find(e => e.number === lineKeys[i].number));
      }
      for (var i in lineKeys){
        if (lineKeys[i].is_blf == "Y" && !state.lineBLF.find(e => e.number == lineKeys[i].number)) {
          console.log('adding lineKey ', lineKeys[i].number);
          var lineKey = {number: lineKeys[i].number, blfState: null}
          state.lineBLF.push(lineKey);
          this._vm.$sip.subscribe(blfDelegate.bind(lineKey), lineKey.number);        
        }
      }          
      state.lineKeys = lineKeys;
    },
    number: (state, val) => { state.number = val; },   
    updateMessages: (state, messages) => {
      // assume eevreything has been read on initial load.
      // that will change at some point when we track it serrver side
      // state.messages = messages.map(obj=> ({ ...obj, unread: false }));
      state.messages = messages;
    },
    updateMsgGroups: (state, msgGroups) => {
      state.msgGroups = msgGroups;
    },
    updateUser: function(state, user) {
      state.user = user;
    },
    users: (state, users) => {
      Vue.set(state, 'users', users);
    },
    messageAdd: (state, message) => {
      state.messages.push(message);
    },
    messageSubscription: (state, val) => {
      state.messageSubscription = val;
    },
    smsFromNumbers: (state, val) => {
      state.smsFromNumbers = val;
    },

  },
  actions: {
    // This is how we mutate app settings to reflect a new auth token.
    // This will always be passed a state object (such as an emptyState),
    // and it just changes the relevant values for the new token.
    async setStateFromAuthToken({dispatch, commit, state}) {

      let at = localStorage.getItem('authorizationToken');

      // If the token is falsy, don't change anything.
      // We know that a falsy token isn't valid.
      if (!at) return;

      // Get the user. 
      let api = new Api(global.gqlClient());
      let user = await api.userFromToken(at);
      commit('smsFromNumbers', user.SMSFromNumbers);

      console.log('in appstate, user is: ', user);



      // No user associated with the token? Change nothing.
      if (!user) {
        LogRocket.identify(null, null);
        // Associate Firebase notifications with the user
        const fcm = FCMFactory.getInstance();
        fcm.disassociateToken();
        return;
      }
      // It's valid! Mutate the token and user
      commit('_user', user);

      LogRocket.identify(user.user_id, user);

      // load the local user config for this user
      let userconfigs = PersistentStorage.get('userconfig');

      // No userconfigs on this device? Make an empty object.
      userconfigs = !userconfigs ? {} : userconfigs;

      // No config for this user? Make an empty object.
      if (!userconfigs[state.user.user_id]) userconfigs[state.user.user_id] = {};

      // Store the userconfig (in case it has changed in the last 2 lines)
      PersistentStorage.set('userconfig', userconfigs);

      // Let's extract what is relevant to just this user
      const config = userconfigs[state.user.user_id];

      // get the conferences for this user
      dispatch('conference/getConferences', null, {root:true});

      // get the queues for this user
      dispatch('queues/getQueues', null, {root:true});

      //subscribe to queue activity
      dispatch('queues/subscribeToQueues');

      // subscribe to messages
      dispatch('subscribeToMessages');
      
      // Get the devices for this users account
      commit('devices', await api.devices());
 
      try {
        updateDevices(state.devices);
      } catch(e) {
      }

      // Does the user have a device configured?
      if (config.deviceId!==undefined) commit('deviceId', config.deviceId);

      // What is the user's useVOIP setting
      if (config.useVOIP === undefined) commit('useVOIP', true);
      if (config.useVOIP !== undefined) commit('useVOIP', config.useVOIP);

      // default microphoneId, cameraId, and speakerId
      state.microphoneId = userconfigs[state.user.user_id].microphoneId;
      console.log('state.microphoneId is ', state.microphoneId);
      if (!state.microphoneId) state.microphoneId = "default";
      console.log('state.microphoneId  2 is ', state.microphoneId);
      state.speakerId = userconfigs[state.user.user_id].speakerId;
      state.cameraId = userconfigs[state.user.user_id].cameraId;

      // Fetch the user's messages & get conference lines
      dispatch('refreshQL');

      // Associate Firebase notifications with the user
      const fcm = FCMFactory.getInstance();
      fcm.associateToken();

      //Initialize Ringtones
      if (state.ringtones.length == 0){
        state.ringtones[0] = {name: 'Ring 1', 'audio': new Audio('ringtones/1.mp3')}
        state.ringtones[1] = {name: 'Ring 2', 'audio': new Audio('ringtones/2.mp3')}
        state.ringtones[2] = {name: 'Ring 3', 'audio': new Audio('ringtones/3.mp3')}
        state.ringtones[3] = {name: 'Ring 4', 'audio': new Audio('ringtones/4.mp3')}
      } 
      for (let i=0;i<state.ringtones.length;i++) {
        let rt = state.ringtones[i];
        if (rt.name == config.ringtoneName) {
          state.ringtone = rt;
        }
      }
      if (!state.ringtone) state.ringtone = state.ringtones[0];

      return 1;
    },

    async refreshQL({ commit, dispatch, state }) {
      let api = new Api(global.gqlClient());
      let result = await api.myConferences();
      if (!result) return;

      commit('users', result.data.usersForMessaging);

      //dispatch('getMessages');
      dispatch('resubscribeToMessages');

    },
    async getMsgGroups({commit}) {
      commit('gettingMsgGroups', true);
      let msgGroupQry = global.gql(msgGroupQryTxt);
      console.log('asing for msgGroups');
      const variables = { id: localStorage.getItem('authorizationToken') };
      let result = await global.apollo.query({ query: msgGroupQry, variables, fetchPolicy: 'network-only' });
        
      console.log('msggroups are in');
      console.log(result);
      commit('updateMsgGroups', result.data.myMsgGroups);
      commit('gettingMsgGroups', false);

    },
    getMessages({ commit }) {
      let msgQry = global.gql(messageQry);
      console.log('****** INSIDE GETMESSSAGES ***************');

      const variables = { id: localStorage.getItem('authorizationToken') };
      global.apollo.query({ query: msgQry, variables, fetchPolicy: 'network-only' })
        .then(function(result) {
          // self.users = result.data.users;
          commit('updateMessages', result.data.messages);
          
          //console.log(result);
          commit('updateMsgGroups', result.data.myMsgGroups);

          commit('smsFromNumbers', result.data.me.SMSFromNumbers);
        })
        .then(function() {
          // console.log('gonna set conferences');
          // self.setCurrentConference()
        })
    },
    setMicrophoneId({commit, getters}, id) {
      commit('microphoneId', id);
      if (getters['sip/session']) {
        this._vm.$sip.reInvite(getters['sip/session']);
      }
    },
    setCameraId({commit, getters}, id) {
      commit('cameraId', id);
      if (getters['sip/session']) {
        this._vm.$sip.reInvite(getters['sip/session']);
      }
    },
    setSpeakerId({commit, getters}, id) {
      console.log('dispatching setSpeakerId to ' + id);
      commit('speakerId', id);
      if (getters['sip/session']) {
        this._vm.$sip.setSpeakerId(getters['sip/session'],id);
      }
    },

    updateDevice: async function({commit}, device) {
      let deviceMutation = ` 
      mutation deviceMutation($input: DeviceInput) {
        device(input: $input) {
          device_id nickname click2call_token user_id pairing_strategy
        }
      }`;
      let vars = {input: {
        device_id: device.device_id,
        pairing_strategy: device.pairing_strategy,
      }}
      let result = await global.gqlClient().request(deviceMutation, vars);
      commit('device', result.device);
    },
    updateUser: async function({commit}, val) {
      commit('updateUser', val);
      return true;
    },
    async login({dispatch}, vars) {
      const gqlClient = global.gqlClient();
      let result=await gqlClient.request(loginMutation, vars);

      // Did the we get a token and user?
      if (result.userLogin===null) return;

      // Update the auth token
      localStorage.setItem('authorizationToken', result.userLogin.token);

      // Now set the app state
      await dispatch('setStateFromAuthToken');
    },
    async logout({commit}) {
      // Dissasociate the Firebase Messaging token
      const fcm = FCMFactory.getInstance();
      fcm.disassociateToken();
      
      // Remove the auth token
      PersistentStorage.remove('authorizationToken');

      // reinitialize the application state.
      commit('setAppState', emptyState());
      return 1;
    },
    async setStateForGuestConferenceUser({dispatch, state, commit}, urlToken) {
      let api = new Api(global.gqlClient());

      if (!state.user) {
        commit('updateUser', {user_id: 'guest'});
      }

      let userconfigs = PersistentStorage.get('userconfig');

      // No userconfigs on this device? Make an empty object.
      userconfigs = !userconfigs ? {} : userconfigs;

      // No config for this user? Make an empty object.
      if (!userconfigs[state.user.user_id]) userconfigs[state.user.user_id] = {};

      // Store the userconfig (in case it has changed in the last 2 lines)
      PersistentStorage.set('userconfig', userconfigs);


      // Get the devices for this users account
      if (state.user.user_id == 'guest') {
        let d = await api.guestConferenceUserDevice(urlToken);
        commit('devices', [d]);
        commit('device', d);
        commit('deviceId', d.device_id);
        console.log(d);
      }

      // make sure user is using voip
      commit('useVOIP', true);
      return 1;
    },
    async messageAdd({state}, message) {


      // i need a api function to add a message with attachment
      let file_s3_region = null;
      let file_s3_bucket = null;
      let file_s3_key = null;
      let file_original_name = null;
      let file_content_type = null;
      let file_size = null;
      if (message.attachment) {
        const form = new FormData();
        //form.append('file', fs.createReadStream(argv.audioFile));
        form.append('file', message.attachment);
        form.append('msg_group_id', message.msg_group_id);
        form.append('authorization', encodeURIComponent(state.device.click2call_token) )

        let response = await Vue.http.post(global.expressAPIUrl + "/message/file", form);
        console.log(response);
        file_s3_region = response.body.file_s3_region;
        file_s3_bucket = response.body.file_s3_bucket;
        file_s3_key = response.body.file_s3_key;
        file_original_name = response.body.file_original_name;
        file_content_type = response.body.file_content_type;
        file_size = response.body.file_size;
      }

      const variables = {
        input: {
          msg_group_id: message.msg_group_id,
          text: message.text,
          file_s3_region: file_s3_region,
          file_s3_bucket: file_s3_bucket,
          file_s3_key: file_s3_key,
          file_original_name: file_original_name,
          file_content_type: file_content_type,
          file_size: file_size,
        },
      };
      const gqlClient = global.gqlClient();
      await gqlClient.request(messageAddMutation, variables)
      return 1;
    },
    
    setReadAllMessagesInGroup({state}, msgGroupId) {
      const variables = {
        msgGroupId,
      };
      const gqlClient = global.gqlClient();
      // only send trraffic if we think there aer unerad message
      gqlClient.request(setReadAllMessagesInGroupMutation, variables);
    },
    subscribeToMessages({commit, state }) {
      let self = this;
      const subqry = global.gql(onMessageAddMutation);
      console.log('***************subscribing to messages *************')
      const sub = global.apollo.subscribe({
        query: subqry,
        variables: { authorization: localStorage.getItem('authorizationToken') },
      }).subscribe({
        next (data) {
          // Notify your application with the new arrived data
          //console.log('reveived some sort of data');
          let m = data.data.onMessageAdd;
          console.log('got message: ', m);
          m.unread = true;
          if (state.activeMsgGroup && state.activeMsgGroup.msg_group_id === m.msg_group_id) {
            state.activeMsgGroup.Messages.push(m);
          }

          /*if ((m.from_id == null)) {
            commit('messageAdd', m);
          } else {
            console.log('not showing the message');
          }*/
          commit('messageAdd', m);
          console.log(Vue);
          let isNewGroup = true;
          for (let i = 0; i < state.msgGroups.length; i++){
            let group = state.msgGroups[i];
            if (m.msg_group_id == group.msg_group_id){
              isNewGroup = false;
              console.log('setting last message');
              Vue.set(group, 'last_message', m.text);
              let datetime = m.dated
              Vue.set(group, 'last_message_datetime', datetime);
              console.log('m is', m.dated);
              console.log('datetime is', datetime);
              if (state.activeMsgGroup && group.msg_group_id != state.activeMsgGroup.msg_group_id) {
                Vue.set(group, 'unread_messages', group.unread_messages ? group.unread_messages++: 1);
              }
            }
          }
          if (isNewGroup) {
            self.dispatch('resubscribeToMessages');
            self.dispatch('getMsgGroups');
          }
          console.log('unsent messages');
          console.log(state.unsentMessages.length);
          for (let i = 0; i < state.unsentMessages.length; i++){
            if (state.unsentMessages[i].user_id == m.from_id && state.unsentMessages[i].message.trim() == m.text.trim()) {
              console.log('unsent message ', state.unsentMessages[i].message, ' finished sending')
              state.unsentMessages.splice(i, 1);
              break;
            }
            else {
              console.log('unsent message ', state.unsentMessages[i], ' did not equal ', m);
            }
          }
          console.log('unsentMessages after loop: ', state.unsentMessages);
          Vue.set(state, 'msgGroups', state.msgGroups)
        },
      });
      commit('messageSubscription', sub);  
    },
    resubscribeToMessages({state, dispatch}) {
      if (state.messageSubscription) {
        state.messageSubscription.unsubscribe();
      }
      dispatch('subscribeToMessages');
    },
  },
};

export default vuex;
